import Store from "@/store/index.js";
import axios from 'axios';
const domain = Store.state.domain;

export default {
    async ExpedientesConcluidosExcel(mes, anio) {
        var formData = new FormData();
        formData.append("mes", mes);
        formData.append("anio", anio);
        let response = await axios.post(`${domain.domainNameForApi}Utilidades/ExpedientesConcluidosExcel`, formData);
        return response.data;
    },

    async ValidarEstadistico(nrid) {
        var formData = new FormData();
        formData.append("nrid", nrid);
        let response = await axios.post(`${domain.domainNameForApi}Recuperaciones/ValidarEstadistico`, formData);
        return response.data;
    },

    async ObtenerDatosDocs(nrid) {
        var formData = new FormData();
        formData.append("nrid", nrid);
        let response = await axios.post(`${domain.domainNameForApi}Recuperaciones/ObtenerDatosDocs`, formData);
        return response.data;
    },

    async ObtenerValidacionAseg(nrid) {
        var formData = new FormData();
        formData.append("nrid", nrid);
        let response = await axios.post(`${domain.domainNameForApi}Recuperaciones/ObtenerValidacionAseg`, formData);
        return response.data;
    },



    async ObtenerTipoMovimientos() {

        let response = await axios.post(`${domain.domainNameForApi}Recuperaciones/ObtenerTipoMovimientos`);
        return response.data;
    },

    async ObtenerDocumentosDanos() {

        let response = await axios.post(`${domain.domainNameForApi}Recuperaciones/ObtenerDocumentosDanos`);
        return response.data;
    },

    async ObtenerAseguradoras() {

        let response = await axios.post(`${domain.domainNameForApi}Recuperaciones/ObtenerAseguradoras`);
        return response.data;
    },

    async ObtenerDatosRecuperaciones(nrid) {
        var formData = new FormData();
        formData.append("nrid", nrid);
        let response = await axios.post(`${domain.domainNameForApi}Recuperaciones/ObtenerDatosRecuperaciones`, formData);
        return response.data;
    },

    async InsertarMovimientoConfPago(data) {

        let response = await axios.post(`${domain.domainNameForApi}Recuperaciones/InsertarMovimientoConfPago`, data);
        return response.data;
    },

    async InsertarMovimientoConfPagoDanios(data) {

        let response = await axios.post(`${domain.domainNameForApi}Recuperaciones/InsertarMovimientoConfPagoDanios`, data);
        return response.data;
    },

    async ValidaFirmaElectronica(nrreporte, svindice, usfirma) {
        var formData = new FormData();
        formData.append("usfirma", usfirma);
        formData.append("reporte", nrreporte);
        formData.append("indice", svindice);
        let response = await axios.post(`${domain.domainNameForApi}Recuperaciones/ValidaFirmaElectronica`, formData);
        return response.data;
    },

    async AgregarPagoNuevo(data) {

        let response = await axios.post(`${domain.domainNameForApi}Recuperaciones/AgregarPagoNuevo`, data);
        return response.data;
    },

    async ObtenerDetallePago(dfid) {
        var formData = new FormData();
        formData.append("dfid", dfid);
        let response = await axios.post(`${domain.domainNameForApi}Recuperaciones/ObtenerDetallePago`, formData);
        return response.data;
    },

    async ObtenerValidacionSigPago(data) {

        let response = await axios.post(`${domain.domainNameForApi}Recuperaciones/ObtenerValidacionSigPago`, data);
        return response.data;
    },

    async InsertarMovimientoConfPagoMayoralSiguiente(data) {

        let response = await axios.post(`${domain.domainNameForApi}Recuperaciones/InsertarMovimientoConfPagoMayoralSiguiente`, data);
        return response.data;
    },

    async BusquedaRecuperaciones(data) {
        var formData = new FormData();
        formData.append("cliente", data.cliente);
        formData.append("fecIni", data.dateStart);
        formData.append("fecFin", data.dateEnd);
        let response = await axios.post(`${domain.domainNameForApi}Recuperaciones/BusquedaRecuperacionesExcel`, formData, data);
        return response.data;
    },

    async RecuperacionesPendientesExcel() {

        let response = await axios.post(`${domain.domainNameForApi}Recuperaciones/RecuperacionesPendientesExcel`);
        return response.data;
    },
    async ObtenerClientes() {
        let response = await axios.post(`${domain.domainNameForApi}Recuperaciones/ObtenerClientes`);
        return response.data;
    },

}